import React from "react";
import { ReactComponent as Folder } from "assets/img/svg/Folder2.svg";
import { ReceiptListContext } from "./context";

const NoReceiptsFound = ({ isCentralizedAdm = false }) => {
  const { filterCount } = React.useContext(ReceiptListContext);

  return (
    <div
      className="d-flex flex-column justify-content-center align-items-center"
      style={{ width: "100%", height: "100%" }}
    >
      <Folder className="mb-2" />
      <span className="text-red text-bold">
        No Receipts Found {filterCount || isCentralizedAdm ? "" : "for Today"}
      </span>
    </div>
  );
};

export default NoReceiptsFound;
